import { format } from "date-fns";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { getDownloadWoundReportCSVDetails, getWoundDashBoardAssessment } from "../../../app/woundReportSlice";
import { DASHBOARD_WOUNDASSESSMENT, LIST_VIEW_LIMIT } from "../../../constants";
import Spreadsheet from "../../../static/images/ExportSpredsheet.svg";
import { DataTable, Pagination } from "../../secondary";
import style from "./report.module.scss";
import { useHistory } from "react-router-dom";
import { Button } from "../../primary";

export const Report = ({ woundProgressValue, tempPayload, selectedDivOption }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const userDetails = useSelector((state) => state.user);
  const [adminAccess, setAdminAccess] = useState(false);
  useEffect(() => {
    if (userDetails && userDetails.role === "ExternalStandardUser") {
      setAdminAccess(true);
    }
  }, [userDetails]);

  useEffect(() => {
    setSortType("");
    setOffSet(0);
    setActivePage(1);
    const woundAssessmentPayload = { ...tempPayload, optionSelected: selectedDivOption, woundProgress: woundProgressValue };
    const listPayLoad = {};
    listPayLoad["url"] = DASHBOARD_WOUNDASSESSMENT;
    listPayLoad["method"] = "Post";
    listPayLoad["payload"] = woundAssessmentPayload;
    listPayLoad["queryParam"] = { offSet: 0, limit: LIST_VIEW_LIMIT };
    if (woundAssessmentPayload && woundAssessmentPayload.facility && woundAssessmentPayload.facility.length > 0) {
      dispatch(getWoundDashBoardAssessment(listPayLoad));
    }
  }, [tempPayload, selectedDivOption, woundProgressValue]);
  const [activePage, setActivePage] = useState(1);
  const [offSet, setOffSet] = useState(0);
  const [sortType, setSortType] = useState("");
  const woundAssessmentData = useSelector((state) => state.woundreport.woundAssessmentData);

  const woundReportCsv = useSelector((state) => state.woundreport.woundReportCsv);
  const csvLink = useRef();

  const getFileName = () => {
    const csvDownloadDate = format(new Date(), "MM-dd-yyyy");
    return `NE1-Wounds-Report-${csvDownloadDate}.csv`;
  };

  const fileName = useMemo(() => getFileName(), []);

  const handleDownloadCSV = async () => {
    const total = woundAssessmentData?.metadata?.total ?? 0;
    if (!total) return;

    const queryParam = `limit=${total}&offSet=0`;

    const payload = {
      ...tempPayload,
      optionSelected: selectedDivOption,
      woundProgress: woundProgressValue,
    };

    if (!payload?.facility?.length) return;

    await dispatch(getDownloadWoundReportCSVDetails(payload, queryParam));

    setTimeout(() => {
      csvLink.current?.link?.click();
    }, 0);
  };

  const columns = [
    {
      Header: "MRN #",
      accessor: "mrn",
      restWidth: "100px",
    },
    {
      Header: "Patient's name",
      accessor: "patientName",
      restWidth: "150px",
    },
    {
      Header: "Wound name",
      accessor: "woundName",
      restWidth: "220px",
    },
    {
      Header: "History/Cause",
      accessor: "historyCause",
      restWidth: "280px",
    },
    {
      Header: "Classification",
      accessor: "classification",
      restWidth: "200px",
    },
    {
      Header: "Last assessed",
      accessor: "lastAccessed",
      restWidth: "150px",
    },
    {
      Header: "Admission date",
      accessor: "admissionDate",
      restWidth: "250px",
    },
    {
      Header: "Discharge date",
      accessor: "dischargeDate",
      restWidth: "250px",
    },
    {
      Header: "HPR Variable 1 - Worst Tissue Type",
      accessor: "worstTissueType",
      restWidth: "265px",
    },
    {
      Header: "HPR Variable 2 - Surface Area Value",
      accessor: "surfaceAreaValue",
      restWidth: "265px",
    },
    {
      Header: "HPR Variable 3 - Intact Value",
      accessor: "intactValue",
      restWidth: "265px",
    },
  ];

  //redirect
  const getSelectedRowData = (data) => {
    if (data && !adminAccess) {
      history.push(`/${"patients"}/${data.ne1Id}/${"assessment"}/${data.woundId}`);
    }
  };

  const deleteDataList = () => {};

  const selectRowCount = () => {};

  const handleSort = useCallback(
    (data) => {
      if (data && data.sortBy[0] && data.sortBy[0].id) {
        const woundAssessmentPayload = { ...tempPayload, optionSelected: selectedDivOption, woundProgress: woundProgressValue };
        const sortingColumn = data.sortBy[0];
        const sortingType = sortingColumn ? (sortingColumn.desc ? ":DESC" : ":ASC") : "";
        let sortParam = sortingColumn.id + sortingType;
        const listPayLoad = {};
        listPayLoad["url"] = DASHBOARD_WOUNDASSESSMENT;
        listPayLoad["method"] = "Post";
        listPayLoad["payload"] = woundAssessmentPayload;
        listPayLoad["queryParam"] = { offSet: isNaN(offSet) === true ? 0 : offSet, limit: LIST_VIEW_LIMIT, sort: sortParam };
        setSortType(sortParam);
        if (woundAssessmentPayload && woundAssessmentPayload.facility && woundAssessmentPayload.facility.length > 0) {
          dispatch(getWoundDashBoardAssessment(listPayLoad));
        }
      }
    },
    [dispatch, tempPayload, selectedDivOption, woundProgressValue, offSet]
  );

  const getActivePage = (data) => {
    setActivePage(data);
    const woundAssessmentPayload = { ...tempPayload, optionSelected: selectedDivOption, woundProgress: woundProgressValue };
    const listPayLoad = {};
    listPayLoad["url"] = DASHBOARD_WOUNDASSESSMENT;
    listPayLoad["method"] = "Post";
    listPayLoad["payload"] = woundAssessmentPayload;
    listPayLoad["queryParam"] = {
      limit: LIST_VIEW_LIMIT,
      offSet: data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT < LIST_VIEW_LIMIT ? 0 : data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT,
      sort: sortType ? sortType : "",
    };
    setOffSet(data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT < LIST_VIEW_LIMIT ? 0 : data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT);
    if (woundAssessmentPayload && woundAssessmentPayload.facility && woundAssessmentPayload.facility.length > 0) {
      dispatch(getWoundDashBoardAssessment(listPayLoad));
    }
  };

  const fileHeaders = [
    { label: "MRN #", key: "mrn" },
    { label: "Patient name", key: "patientName" },
    { label: "DOB", key: "dob" },
    { label: "Wound name", key: "woundName" },
    { label: "History/Cause", key: "historyCause" },
    { label: "Classification", key: "classification" },
    { label: "Wound acquired", key: "woundAcquired" },
    { label: "Photo taken by", key: "photoTakenBy" },
    { label: "Photo taken on", key: "photoTakenOn" },
    { label: "Assessed by", key: "lastAssessedby" },
    { label: "Last assessed", key: "lastAccessed" },
    { label: "Signed", key: "signed" },
    { label: "Reviewed & locked", key: "reviewedLocked" },
    { label: "HPR Variable 1 - Worst Tissue Type", key: "worstTissueType" },
    { label: "HPR Variable 2 - Surface Area Value", key: "surfaceAreaValue" },
    { label: "HPR Variable 3 - Intact Value", key: "intactValue" },
  ];

  return (
    <>
      <div className="col-sm-12 mb-2 justify-content-end d-flex">
        <span className={style.down_spread}>
          <Button type="button" className={style.download_btn} onClick={handleDownloadCSV}>
            <img src={Spreadsheet} alt="" /> Download as CSV
          </Button>
          <CSVLink
            headers={fileHeaders}
            data={woundReportCsv?.woundAssessment || []}
            filename={fileName}
            target="_blank"
            ref={csvLink}
            style={{ display: "none" }}
          />
        </span>
      </div>
      {woundAssessmentData && woundAssessmentData?.woundAssessment && (
        <div className="col-12" id={"overviewLoadingTable"}>
          <DataTable
            columns={columns}
            data={woundAssessmentData && woundAssessmentData?.woundAssessment}
            sorting={true}
            getSelectedRowData={getSelectedRowData}
            setSelectedRows={selectRowCount}
            onSort={handleSort}
            detailView={true}
            deleteDataList={deleteDataList}
            showFixedColumn={false}
            workListView={true}
            reportView={true}
            removeCursor={userDetails.role === "ExternalStandardUser" ? true : false}
            sortType={sortType ? sortType : ""}
          />
        </div>
      )}
      {Array.isArray(woundAssessmentData.woundAssessment) && woundAssessmentData.woundAssessment.length > 1 && (
        <Pagination
          activePage={activePage}
          itemsCountPerPage={woundAssessmentData?.metadata ? woundAssessmentData?.metadata?.limit : 50}
          totalItemsCount={woundAssessmentData?.metadata ? woundAssessmentData?.metadata?.total : 0}
          getActivePage={getActivePage}
          reportView={true}
        />
      )}
    </>
  );
};
